import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import pic1 from "./VaticanTheGramAssets/Francior-post.webp";
import pic2 from "./VaticanTheGramAssets/Socialist-post.webp";
import pic3 from "./VaticanTheGramAssets/Sister-post.webp";
import pic4 from "./VaticanTheGramAssets/Virginia-post.webp";

import dp1 from "./VaticanTheGramAssets/Francoir-pfp.webp";
import dp2 from "./VaticanTheGramAssets/Socialist-pfp.webp";
import dp3 from "./VaticanTheGramAssets/Sister-pfp.webp";
import dp4 from "./VaticanTheGramAssets/Virginia-pfp.webp";

export const VaticanTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "francoisxodier", image: dp1 },
    Date: "18 April 2025",
    Image: pic1,
    Likes: "5,189",
    Caption: "An immense privilege to be invited to the Swiss Grand Prix today",
    Location: "",
  },
  {
    Profile: { name: "ItaliaSocialista", image: dp2 },
    Date: "18 April 2025",
    Image: pic2,
    Likes: "12.8K",
    Caption:
      "On Sunday, join our march against Fascism from Piazza Navona to Parliament 🚫",
    Location: "",
  },
  {
    Profile: { name: "ourladyofcaramoto", image: dp3 },
    Date: "18 April 2025",
    Image: pic3,
    Likes: "1,362",
    Caption:
      "Good Friday procession remembering our Lord Jesus Christ’s suffering on the cross",
    Location: "",
  },
  {
    Profile: { name: "virginiafaenzi", image: dp4 },
    Date: "18 April 2025",
    Image: pic4,
    Likes: "27,883",
    Caption: "Thank you to Pope Benedict for such a moving Tre Ore mass ✝️",
    Location: "",
  },
];
